import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { IconButton, Popover, List, ListItemButton, ListItemText, ListSubheader } from "@mui/material"
import { get, map, find } from "lodash"
import classNames from "classnames"
import OPTooltip from "components/material/tooltip"
import { OPTION_SHAPE } from "components/list-item-dropdown"
import { METRIC_TYPES_SHAPE, METRICS_SHAPE } from "helpers/metrics/shapes"
import UnitIcon from "./unit-icon"
import SettingsButton from "./settings-button"

export default function MetricDisplayUnitSelector({ options, unit, classes, alignMenu, onChange, openSettingsDialog, disabled, metric }) {
  const [selectedOption, setSelectedOption] = useState()
  const [anchor, setAnchor] = useState(null)

  useEffect(() => {
    setSelectedOption(find(options, { id: unit }))
  }, [options, unit])

  const makeListItemClick = (unit) => () => {
    onChange(unit)
    setSelectedOption(find(options, ({ id }) => id === unit))
    setAnchor(null)
  }

  return <div className="change-display-unit">
    <OPTooltip title={disabled ? "Display unit cannot be changed" : "Change display unit"}>
      <span>
        <IconButton
          className={classNames("metric-default-unit-selector", unit, get(classes, "toggle"))}
          onClick={(e) => setAnchor(e.currentTarget)}
          disabled={disabled}
          size="large"
        >
          <UnitIcon selectedUnit={selectedOption} metric={metric} />
        </IconButton>
      </span>
    </OPTooltip>

    <Popover
      classes={{
        paper: classNames("metric-default-unit-selector-info", get(classes, "popper")),
      }}
      open={Boolean(anchor)}
      anchorEl={anchor}
      onClose={() => setAnchor(null)}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: alignMenu,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: alignMenu,
      }}
    >
      <List className={classNames("metric-default-unit-selector-options", get(classes, "options"))}>
        <ListSubheader component="div" className="nested-list-subheader">
          <span>Choose display unit</span>
          <SettingsButton {...{
            onClick: () => {
              setAnchor(null)
              openSettingsDialog()
            },
          }}
          />
        </ListSubheader>
        {map(options, ({ id: unitId, primaryText, secondaryText, isDefault, tooltip }) => {
          const listItem = <ListItemButton key={unitId} selected={selectedOption ? selectedOption.id === unitId : isDefault}>
            <ListItemText
              onClick={makeListItemClick(unitId)}
              primary={primaryText}
              secondary={<>{secondaryText}{isDefault && <i className="default">Default</i>}</>}
            />
          </ListItemButton>
          return tooltip ? <OPTooltip title={tooltip} key={unitId} placement="bottom-start"><span>{listItem}</span></OPTooltip> : listItem
        })}
      </List>
    </Popover>
  </div>
}

MetricDisplayUnitSelector.propTypes = {
  alignMenu: PropTypes.string,
  classes: PropTypes.object,
  unit: METRIC_TYPES_SHAPE.isRequired,
  options: PropTypes.arrayOf(OPTION_SHAPE).isRequired,
  onChange: PropTypes.func,
  openSettingsDialog: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  metric: METRICS_SHAPE.isRequired,
}
